import { MatDialog } from '@angular/material/dialog';
import { PlanType } from '../../shared/subscription/subscription.models';
import { ZevaPageSelector } from '../core.models';
import { ZEVA_PAGES, ZEVA_PAGE_VIEW_PERMISSION, ZEVA_SUBSYSTEMS } from '../core.static';
import { FeedbackModalComponent } from '../feedback/feedback-modal.component';
import { MODAL_HEIGHT, MODAL_ID, MODAL_WIDTH } from '../support/support.static';
import { NavigationElement } from './sidenav.models';

/* Array that determines the navigation menu */
export const DEFAULT_NAVIGATION: NavigationElement[] = [
  {
    name: ZEVA_SUBSYSTEMS.monitoring.name,
    link: '/' + ZEVA_SUBSYSTEMS.monitoring.slug,
    icon: 'directions_car',
    requireVehicles: true,
    subPages: [
      {
        name: ZEVA_PAGES[ZevaPageSelector.MONITORING_LIVE].name,
        // eslint-disable-next-line max-len
        link: `/${ZEVA_SUBSYSTEMS.monitoring.slug}/${
          ZEVA_PAGES[ZevaPageSelector.MONITORING_LIVE].slug
        }`,
        icon: 'wifi',
        requirePermissions: [ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.MONITORING_LIVE]],
        requireVehicles: true,
      },
      {
        name: ZEVA_PAGES[ZevaPageSelector.MONITORING_REPLAY].name,
        // eslint-disable-next-line max-len
        link: `/${ZEVA_SUBSYSTEMS.monitoring.slug}/${
          ZEVA_PAGES[ZevaPageSelector.MONITORING_REPLAY].slug
        }`,
        icon: 'route',
        premium: true,
        requirePermissions: [ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.MONITORING_REPLAY]],
        requireVehicles: true,
      },
      {
        name: ZEVA_PAGES[ZevaPageSelector.MONITORING_EN].name,
        // eslint-disable-next-line max-len
        link: `/${ZEVA_SUBSYSTEMS.monitoring.slug}/${
          ZEVA_PAGES[ZevaPageSelector.MONITORING_EN].slug
        }`,
        icon: 'battery_charging_full',
        premium: true,
        requirePermissions: [ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.MONITORING_EN]],
        requireVehicles: true,
      },
      {
        name: ZEVA_PAGES[ZevaPageSelector.MONITORING_CONTROL].name,
        // eslint-disable-next-line max-len
        link: `/${ZEVA_SUBSYSTEMS.monitoring.slug}/${
          ZEVA_PAGES[ZevaPageSelector.MONITORING_CONTROL].slug
        }`,
        icon: 'settings_remote',
        premium: true,
        requirePermissions: [ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.MONITORING_CONTROL]],
        requireVehicles: true,
      },
      {
        name: ZEVA_SUBSYSTEMS.maintenance.name,
        link: '/' + ZEVA_SUBSYSTEMS.maintenance.slug,
        icon: 'construction',
        premium: true,
        requirePermissions: [ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.MAINTENANCE_LIST]],
        requireVehicles: true,
        onlyForInstance: [PlanType.COMMERCIAL],
      },
      {
        name: ZEVA_SUBSYSTEMS.insights.name,
        link: '/' + ZEVA_SUBSYSTEMS.insights.slug,
        icon: 'speed',
        premium: true,
        requirePermissions: [ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.INSIGHTS]],
        requireVehicles: true,
      },
      {
        name: ZEVA_SUBSYSTEMS.analytics.name,
        link: '/' + ZEVA_SUBSYSTEMS.analytics.slug,
        icon: 'query_stats',
        premium: true,
        requirePermissions: [ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.ANALYTICS_VEHICLE]],
        requireVehicles: true,
      },
      // {
      //   name: ZEVA_PAGES[ZevaPageSelector.MONITORING_GEOFENCES].name,
      //   // eslint-disable-next-line max-len
      //   link: `/${ZEVA_SUBSYSTEMS.monitoring.slug}/${
      //     ZEVA_PAGES[ZevaPageSelector.MONITORING_GEOFENCES].slug
      //   }`,
      //   icon: 'fence',
      //   premium: true,
      //   permissionsRequired: [ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.MONITORING_GEOFENCES]],
      // },
    ],
  },
  {
    name: 'Battery Health',
    link: '/battery-health',
    icon: 'health_and_safety',
    requireVehicles: false,
    onlyForInstance: [PlanType.COMMERCIAL],
    subPages: [
      {
        name: 'battery_health.dashboard',
        icon: 'analytics',
        link: '/battery-health',
        requirePermissions: [],
      },
    ]
  },
  {
    name: ZEVA_SUBSYSTEMS.admin.name,
    link: '/' + ZEVA_SUBSYSTEMS.admin.slug,
    icon: 'tune',
    subPages: [
      {
        name: ZEVA_PAGES[ZevaPageSelector.ADMIN_ACCOUNT].name,
        link: `/${ZEVA_SUBSYSTEMS.admin.slug}/${ZEVA_PAGES[ZevaPageSelector.ADMIN_ACCOUNT].slug}`,
        icon: 'business_center',
        requirePermissions: [ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.ADMIN_ACCOUNT]],
        onlyForInstance: [PlanType.COMMERCIAL],
      },
      {
        name: ZEVA_PAGES[ZevaPageSelector.ADMIN_PROFILE].name,
        link: `/${ZEVA_SUBSYSTEMS.admin.slug}/${ZEVA_PAGES[ZevaPageSelector.ADMIN_PROFILE].slug}`,
        icon: 'manage_accounts',
      },
      {
        name: ZEVA_PAGES[ZevaPageSelector.ADMIN_FLEET].name,
        link: `/${ZEVA_SUBSYSTEMS.admin.slug}/${ZEVA_PAGES[ZevaPageSelector.ADMIN_FLEET].slug}`,
        icon: 'garage',
        requirePermissions: [ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.ADMIN_FLEET]],
        onlyForInstance: [PlanType.COMMERCIAL],
      },
      {
        name: ZEVA_PAGES[ZevaPageSelector.ADMIN_SUBSCRIPTION].name,
        link: `/${ZEVA_SUBSYSTEMS.admin.slug}/${
          ZEVA_PAGES[ZevaPageSelector.ADMIN_SUBSCRIPTION].slug
        }`,
        icon: 'star',
        requirePermissions: [ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.ADMIN_SUBSCRIPTION]],
        requireVehicles: true,
      },
    ],
  },
];

/* Array that determines the get started menu */
export const GET_STARTED_NAVIGATION: NavigationElement[] = [
  {
    name: ZEVA_PAGES[ZevaPageSelector.GET_STARTED].name,
    icon: 'directions_car',
    requirePermissions: [ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.ADMIN_SUBSCRIPTION]],
  },
  {
    name: ZEVA_SUBSYSTEMS.admin.name,
    link: '/' + ZEVA_SUBSYSTEMS.admin.slug,
    icon: 'tune',
    subPages: [
      {
        name: ZEVA_PAGES[ZevaPageSelector.ADMIN_PROFILE].name,
        link: `/${ZEVA_SUBSYSTEMS.admin.slug}/${ZEVA_PAGES[ZevaPageSelector.ADMIN_PROFILE].slug}`,
        icon: 'manage_accounts',
        requirePermissions: [ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.ADMIN_PROFILE]],
      },

      {
        name: ZEVA_PAGES[ZevaPageSelector.ADMIN_SUBSCRIPTION].name,
        link: `/${ZEVA_SUBSYSTEMS.admin.slug}/${
          ZEVA_PAGES[ZevaPageSelector.ADMIN_SUBSCRIPTION].slug
        }`,
        icon: 'star',
        requirePermissions: [ZEVA_PAGE_VIEW_PERMISSION[ZevaPageSelector.ADMIN_SUBSCRIPTION]],
      },
    ],
  },
];

/* Array that determines the external links menu */
export const EXTERNAL_LINKS: NavigationElement[] = [
  // {
  //   name: 'Invite a Friend!',
  //   icon: 'stars',
  //   link: `/${ZEVA_SUBSYSTEMS.admin.slug}/${ZEVA_PAGES[ZevaPageSelector.ADMIN_REFERRAL].slug}`,
  //   externalLink: false,
  // },
  {
    name: 'Help',
    icon: 'contact_support',
    link: `/${ZEVA_PAGES[ZevaPageSelector.FAQ].slug}`,
  },
  {
    name: 'Feedback',
    icon: 'feedback',
    action: (dialog: MatDialog) => {
      dialog.open(FeedbackModalComponent, {
        id: MODAL_ID,
        width: MODAL_WIDTH,
        height: MODAL_HEIGHT,
        maxWidth: '600px',
        maxHeight: '618px',
      });
    },
  },
  {
    name: 'zevaglobal.com',
    link: 'https://www.zevaglobal.com/',
    externalLink: true,
    icon: 'language',
  },
  {
    name: 'iOS App',
    link: 'https://apps.apple.com/us/app/zeva/id6476576625',
    externalLink: true,
    icon: 'apple',
  },
  {
    name: 'Android App',
    link: 'https://play.google.com/store/apps/details?id=com.zevaglobal.zeva',
    externalLink: true,
    icon: 'android',
  },
];
